import { render } from "./CustomTableView.vue?vue&type=template&id=0a3aaad6&scoped=true&ts=true"
import script from "./CustomTableView.vue?vue&type=script&lang=ts"
export * from "./CustomTableView.vue?vue&type=script&lang=ts"

import "./CustomTableView.vue?vue&type=style&index=0&id=0a3aaad6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3aaad6"]])

export default __exports__